import { Component, OnInit, OnDestroy } from '@angular/core';
import {AppDataService} from "../../../services/app-data.service";
import {FormBuilder, FormGroup} from "@angular/forms";
import {CompanyService} from "../../../services/company.service";
import { TranslationService } from '../../../services/translation.service';
import { BaseActionComponent } from './baseAction';


declare let $: any;
declare let Swal:any;

@Component({
    selector : 'light-action',
    templateUrl:'lightAction.html'
})
export class LightActionComponent extends BaseActionComponent{

  public dataList;
  public media
  public level=1;
  public color;
  public kind='spotLight';
  public linkForm: FormGroup;
  public constructor(public translate: TranslationService,public _appData : AppDataService,public fb : FormBuilder, public _companyService : CompanyService) {
    super(translate,_appData,fb,_companyService)
  }
  public processData(action){
    if (!action){
      action={kind:'spotLight',param:{}}
    }
    let thumbnail=null;
    if (this.media){
      thumbnail=this.media.url
    }
    let linkParam = this.linkForm['_value'];
    action.param=linkParam
    if (thumbnail){
      action.param.url=thumbnail
    }
    action.param.kind=this.kind
  }
  public setLight(kind){
    this.kind=kind;
  }
  public selectItem(item) {
    this.media=null
    for (let i = 0; i < this.dataList.length; i++) {
      if (this.dataList[i].id == item.id) {
          this.dataList[i].selected = true;
          this.media=item
      }
      else {
          this.dataList[i].selected = false;
      }
    }
  }  
  public reloadLocalPacks(){
    let list=[]
    if (this.selectedPack){
      list=this.selectedPack.images
    }
    else{
      if (this._appData.room.textures.images) {
        list=this._appData.room.textures.images
      }
    }
    this.dataList = []
    if (this.action.param && this.action.param.url && this.action.param.url.indexOf('http')>=0){
      list.forEach(ic => {
        ic.url = ic.url
        ic.selected = false        
        if (this.action.param) {
          if ((this.action.param.url) == ic.url) {
            ic.selected = true;
            this.media=ic
          }
        }
        this.dataList.push(ic);
      })  
    }
    else{
      if (this.selectedPack){
        list.forEach(ic => {
          ic.selected = false        
          if ((this.action.param && this.action.param.url) == 'pack-'+this.selectedPack.id+'-id-'+ic.id) {
              ic.selected = true;
              this.media=ic
          }
          this.dataList.push(ic);
        })  
      }
      else{
        //nao é um pack veio das texturas.
        list.forEach(ic => {
          ic.selected = false    
          if (!ic.id){ic.id=ic.transaction;}
          if (this.action.param.url){
            if ((this.action.param.url) == 'texture-'+ic.id) {
              ic.selected = true;
              this.media=ic
            }
          }    
          this.dataList.push(ic);
        })  
      }
    }
  }

  public childrenReloadData(){
    let list=[]
    let split=null
    if (this.action.param && this.action.param.url){
      split=this.action.param.url.split('-')
      if (split.length>0 && split[0]=='pack'){
        this.selectedPack=this._appData.room.packs[split[1]]
      }
    }
    if (this.action.param.kind){
      this.kind=this.action.param.kind
    }
    if (this.action.param && this.action.param.color){
      this.color=this.action.param.color;
      this.linkForm = this.fb.group({
        color: this.action.param.color,
        intensity: this.action.param.intensity ? this.action.param.intensity : 1
      });
    }else{
      this.linkForm = this.fb.group({
        color: '',
        intensity: 1
      });
      this.color='';
    }
    this.reloadLocalPacks();

  

  }

    public ngOnInit(): any {
      this.linkForm = this.fb.group({
        color: '',
        intensity: 1
      });


    }


}



// WEBPACK FOOTER //
// C:/prj/liveplanet-app-site/src/app/components/+gameevent/actions/lightAction.ts